export const visit = (vm, at) => {
vm(require("find-and-filter-data/lang/en.lyaml"));
vm(require("ui-addon-emoji-picker/lang/en.lyaml"));
vm(require("routing-ui/lang/en.lyaml"));
vm(require("./common/en.lyaml"));
vm(require("./custom-views-build/en.lyaml"));
vm(require("./preview-card/en.lyaml"));
vm(require("./spaces/en.lyaml"));
at({ "en": { "placeholderKey": "" } });
};